import axios, { AxiosResponse } from 'axios'

import { RequestQuery } from '@models/apiBase'
import { Response } from '@models/apiBase'
import { WithFilter } from '@models/apiBase'
import { ID } from '@models/base'
import { AdministrativeDivisionModel, CountryModel } from '@models/country'

import { API_URL } from '@/constants/constant'

const COUNTRIES_URL = `${API_URL}/countries`
const ADMINISTRATIVE_DIVISION_URL = `${API_URL}/administrative-divisions`

type ResponseCountries = Response<WithFilter<Array<CountryModel>>>

type ResponseAdministrativeDivisions = Response<WithFilter<Array<AdministrativeDivisionModel>>>

type QueryOptionsAdministrativeDivisions = RequestQuery & {
  country_id?: ID
  parent_id?: ID
}

interface ICountriesAPI {
  getOptions: (query: RequestQuery) => Promise<ResponseCountries>
}

interface IAdministrativeDivisionsAPI {
  getOptions: (query: QueryOptionsAdministrativeDivisions) => Promise<ResponseAdministrativeDivisions>
}

export const CountriesAPI: ICountriesAPI = {
  getOptions: async (query) => {
    return axios.post(`${COUNTRIES_URL}/options`, query).then((r: AxiosResponse<ResponseCountries>) => r.data)
  },
}

export const AdministrativeDivisionsAPI: IAdministrativeDivisionsAPI = {
  getOptions: async (query) => {
    return axios
      .post(`${ADMINISTRATIVE_DIVISION_URL}/options`, query)
      .then((r: AxiosResponse<ResponseAdministrativeDivisions>) => r.data)
  },
}
